<span *ngIf="autoplay==0">
    <iframe style="width: 100%; height:100%"
    [src]="youtubeUrl+img.img + '?autoplay=0' | safe: 'resourceUrl'" frameborder="0" allow="autoplay"></iframe>
</span>

<span *ngIf="autoplay==1">
    <iframe style="width: 100%; height:100%"
    [src]="youtubeUrl+img.img + '?autoplay=1' | safe: 'resourceUrl'" frameborder="0" allow="autoplay"></iframe>
</span>